// TextCustomization.jsx
export function applyTextCustomization(editableRef, tag) {
  const sel = window.getSelection();
  if (!sel || !sel.rangeCount) return;
  const range = sel.getRangeAt(0);

  // —————————————————————
  //  Bloque de Quote en nueva línea
  // —————————————————————
  if (tag === 'quote-block') {
    // 1) ¿Ya hay un <blockquote class="custom-quote-block">? -> desenvuelve
    let common = range.commonAncestorContainer;
    if (common.nodeType === Node.TEXT_NODE) common = common.parentNode;
    if (
      common.tagName === 'BLOCKQUOTE' &&
      common.classList.contains('custom-quote-block')
    ) {
      const parent = common.parentNode;
      while (common.firstChild) {
        parent.insertBefore(common.firstChild, common);
      }
      parent.removeChild(common);
      sel.removeAllRanges();
      return;
    }

    // 2) Envolver en bloque <blockquote>
    const block = document.createElement('blockquote');
    block.className = 'custom-quote-block';
    block.textContent = sel.toString();
    range.deleteContents();
    range.insertNode(block);

    // 3) Reposicionar cursor justo después
    range.setStartAfter(block);
    range.setEndAfter(block);
    sel.removeAllRanges();
    sel.addRange(range);
    return;
  }
  
  // Detect existing wrapper
  let common = range.commonAncestorContainer;
  if (common.nodeType === Node.TEXT_NODE) common = common.parentNode;
  if (
    common.tagName === tag.toUpperCase() &&
      common.classList.contains(`custom-${tag}`)
  ) {
    // Unwrap
    const parent = common.parentNode;
    while (common.firstChild) {
      parent.insertBefore(common.firstChild, common);
    }
    parent.removeChild(common);
    sel.removeAllRanges();
    return;
  }
  
  // Apply wrapper
  const el = document.createElement(tag);
  el.className = `custom-${tag}`;
  el.textContent = sel.toString();
  range.deleteContents();
  range.insertNode(el);
  
  // Move cursor
  range.setStartAfter(el);
  range.setEndAfter(el);
  sel.removeAllRanges();
  sel.addRange(range);
}
